import { render, staticRenderFns } from "./NewPartnerLanguageModal.vue?vue&type=template&id=160ae0dc&"
import script from "./NewPartnerLanguageModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnerLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports